// import { Auth0Provider } from "@auth0/auth0-react";
import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import Header from "../components/Header";

export default function MemberInvite(props) {

    const location = useLocation();
    const [searchParams] = useSearchParams();
    const [showRedirect, setShowRedirect] = useState(false);

    useEffect(() => {

        const inviteCode = searchParams.get("invitation"); // Adjust if your query param is different
        const organization = searchParams.get("organization"); // Adjust if your query param is different

        if(inviteCode && organization)
        {
            const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN;
            const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
            const redirectUri = "https://dv.redalign.com"; // Update as needed
      
            const auth0Url = `https://${auth0Domain}/authorize?client_id=${clientId}&response_type=code&scope=openid profile email&redirect_uri=${encodeURIComponent(redirectUri)}&invitation=${inviteCode}&organization=${organization}`;
      
            setShowRedirect(true);
            window.location.href = auth0Url;
        } else {
            console.log("no invitation code");
        }

    }, [location]);

    return (
         <Box sx={{ width: "100vw", height: "100vh", display: 'flex' }}>
            <Box sx={{ width: "100%" }}>
                <Header/>
                <Box sx={{ padding: "50px", alignItems: "center", justifyContent: "flex-start", textAlign: "center" }}>
                    {(showRedirect ? 
                        (<Typography variant="h6" >Redirecting to Auth0...</Typography>)
                        :
                        (<Typography variant="h6" >Invitation data not provided.</Typography>)
                    )}
                </Box>
            </Box>
        </Box>
    );
}